<template>
	<transition name="slide-fade">
		<div class="modal-container">
			<div class="modal groups-modal" @click.stop>
				<div class="modal-header">
					<div class="modal-title">
						<span>Groups</span>
					</div>
					<div class="close" title="close">
						<ion-icon name="ios-close" @click="closeModal"></ion-icon>
					</div>
				</div>
				<div class="modal-body">
					<div v-if="groupsModal.from === 'groups'" style="height:inherit">
						<groups-message
							v-if="showMessageComponent"
							:groupID="activeGroup.groupID"
							:users="activeGroupMembers"
							:groupName="groupName"
							:admin="activeGroup.admin"
							:dateCreated="groupDateCreated"
							:from="componentName"
							@goBack="goBack"
						></groups-message>
					</div>
					<div v-else-if="groupsModal.from === 'groups-list'" style="height:inherit">
						<div v-show="!showMessageComponent" style="height:inherit;position:relative;">
							<h2>
								All groups
								<span class="count">{{$store.state.user.user.groups.length}}</span>
							</h2>
							<groups-list
								class="groups-modal-groups-list"
								:from="componentName"
								@goToMessage="goToMessage"
							></groups-list>
							<new-group-button class="groups-modal-new-group-button" v-if="emailVerified"></new-group-button>
						</div>
						<groups-message
							v-if="showMessageComponent"
							:groupID="activeGroup.groupID"
							:users="activeGroupMembers"
							:groupName="groupName"
							:admin="activeGroup.admin"
							:dateCreated="groupDateCreated"
							:from="componentName"
							@goBack="goBack"
						></groups-message>
					</div>
					<groups-search v-else></groups-search>
				</div>
				<div class="modal-footer">
					<!-- <new-group-button v-if="!showMessageComponent && emailVerified"></new-group-button> -->
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import GroupsSearch from "../groups/groupsSearch/GroupsSearch.vue";
import GroupsList from "../groups/GroupsList.vue";
import GroupsMessage from "../groups/groupsMessage/GroupsMessage.vue";
import NewGroupButton from "../buttons/NewGroupButton.vue";
import { groupsMixin } from "../../mixins/groupsMixin";
import { updateGroupAdmin } from "../../api/groups";
import { sendNotification } from "../../api/notifications";

export default {
	mixins: [groupsMixin],
	data() {
		return {
			users: [],
			activeGroup: {},
			activeGroupMembers: [],
			showMessageComponent: false,
			groupName: "",
			groupDateCreated: null,
			componentName: "groups-modal"
		};
	},
	props: {
		from: {
			type: String
		}
	},
	components: {
		GroupsSearch,
		GroupsList,
		GroupsMessage,
		NewGroupButton
	},
	beforeMount() {
		let following = this.$store.state.user.user.following;
		let followers = this.$store.state.user.user.followers;

		following.forEach(item => {
			if (followers.includes(item)) {
				this.users.push(item);
			}
		});

		let payload = {
			searchableUsers: this.users
		};

		this.$store.commit("updateGroupsModal", payload);

		// this.$store.state.app.app.groupsModal.searchableUsers = this.users
	},
	mounted() {
		const modalContainer = document.querySelector(".modal-container");
		modalContainer.addEventListener("click", this.closeModal);

		if (this.groupsModal.from === "groups") {
			this.activeGroup = this.groupsModal.group;
			this.activeGroupMembers = this.groupsModal.group.membersData;
			this.showMessageComponent = true;
			this.groupName = this.groupsModal.group.groupName;
			this.groupDateCreated = this.groupsModal.group.dateCreated;

			let groupModalTite = window.document.querySelector(".modal-title span");
			groupModalTite.style.marginLeft = "35px";
		}
	},
	computed: {
		groupsModal() {
			return this.$store.getters.getGroupsModal;
		},
		emailVerified() {
			return this.$store.state.user.authUser.emailVerified;
		}
	},
	methods: {
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			this.$store.state.app.app.groupsModal.show = false;
			// BUG Store commit not working
			// //Set payload
			// let payload = {
			//     from: '',
			//     group: {},
			//     show: false,
			// }
			// //Set state
			// this.$store.commit('updateGroupsModal', payload)
		},
		goToMessage(group) {
			this.activeGroup = group;
			this.activeGroupMembers = group.membersData;
			this.showMessageComponent = true;
			this.groupName = group.groupName;
			this.groupDateCreated = group.dateCreated;

			let groupModalTite = window.document.querySelector(".modal-title span");
			groupModalTite.style.marginLeft = "35px";
		},
		goBack(groupToDelete) {
			if (groupToDelete.actionType === "delete") {
				//Remove group from user's groups in db
				let groupRemoved = new Promise((resolve, reject) => {
					resolve(
						this.removeGroupFromAllUsers(this.activeGroupMembers, groupToDelete)
					);
				}).catch(error => {
					// console.log(error);
					reject(new Error(error));
				});

				groupRemoved
					.then(() => {
						const authUser = this.$store.state.user.authUser.uid;
						let memberIDs = this.activeGroupMembers.map(
							item => item.userID || item.objectID
						);
						memberIDs.forEach(member => {
							if (member !== authUser) {
								//Add to all members notifications
								let notification = {
									type: "group-deleted",
									user: authUser,
									dateCreated: Date.now(),
									members: memberIDs.length >= 7 ? this.groupName : memberIDs,
									seen: false
								};

								sendNotification(member, notification);
							}
						});
					})
					.catch(error => {
						// console.log(error);
						throw new Error(error);
					});
			} else if (groupToDelete.actionType === "leave") {
				//Remove group from authUser groups in db
				let groupRemoved = new Promise((resolve, reject) => {
					resolve(this.removeGroupFromAuthUser(groupToDelete));
				}).catch(error => {
					// console.log(error);
					reject(new Error(error));
				});

				groupRemoved
					.then(async () => {
						const authUser = this.$store.state.user.authUser.uid;
						await updateGroupAdmin([groupToDelete.groupID], authUser);
					})
					.catch(error => {
						// console.log(error);
						throw new Error(error);
					});
			}

			//Set payload
			let payload = {
				from: "groups-list",
				group: {}
			};

			//Set state
			this.$store.commit("updateGroupsModal", payload);
			this.showMessageComponent = false;
		}
	}
};
</script>

<style lang="css" src="../../styles/modalStyles.css" scoped></style>
<!--<style lang="scss" scoped>
	@import "../../styles/modalStyles.scss";
</style>-->
<style lang="css" src="../../styles/cardStyles.css" scoped></style>
<style scoped>
.groups-modal {
	transform: none;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
	border-radius: 0px;
	height: 100%;
	margin-left: auto;
	max-height: none;
}

.groups-modal-groups-list {
	max-height: 700px;
	/* height: 520px; */
	height: 75%;
	overflow: auto;
	margin-bottom: 20px;
}

.groups-modal-new-group-button {
	position: absolute;
	width: 100%;
	bottom: 40px;
}

.modal-header {
	height: 5%;
}

.modal-body {
	/* height: 84%; */
	height: 100%;
}

.modal-footer {
	height: 0px;
}

h2 {
	font-weight: bold;
	width: 100%;
	text-align: center;
	padding-bottom: 15px;
	margin-bottom: 10px;
	/* border-bottom: 1px solid #111; */
}

.count {
	height: 18px;
	width: 18px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

@media only screen and (max-width: 540px) {
	.groups-modal {
		top: unset;
		border-radius: 20px 20px 0 0;
		height: 90%;
	}

	.groups-modal-groups-list {
		max-height: 450px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/modals/GroupsModal.vue